export class TaxReturn {
   constructor({id = null, formName = null, state = null, entityType = null}) {
      this.id = id;
      this.formName = formName;
      this.state = state;
      this.entityType = entityType;
   }
}

export class TaxReturnLine {
   constructor({id = null, taxReturnId = null, lineName = null, lineId = null}) {
      this.id = id || lineId;
      this.taxReturnId = taxReturnId;
      this.lineId = lineId;
      this.lineName = lineName;
      this.name = lineName;
   }
}

export class TaxReturnForm {
   constructor({id = null, formName = null, entityType = null, taxReturnLines = []}) {
      this.id = id;
      this.taxReturn = {
         name: formName,
         entityType: entityType,
      };
      this.taxReturnLines =
         taxReturnLines.length > 0 ? taxReturnLines.map((line) => new TaxReturnLine(line)) : [];
   }
}
export default {
   TaxReturn,
   TaxReturnLine,
   TaxReturnForm,
};
